import React, { FC } from 'react';
import { styled } from 'styled-components';
import { IConfig } from '../types/config';
import { IArticle } from '../types/article';
import { IGlobaVariables } from '../components/Layout/styles';

import Layout from '../components/Layout';
import SEO from './../components/Seo';
import Breadcrumbs from '../sections/BreadCrumbs';
import ArticlesRecommended from '../sections/ArticlesRecommended';
import CategoriesSide from '../sections/CategoriesSide';

import EntireArticleBox from '../components/EntireArticleBox';
import { breadcrumbs, routing } from '../translates';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  $config: IConfig;
}>`
  .article {
    &-column-wrapper {
      position: relative;
      display: flex;
      gap: 30px;
      flex-direction: column;
    }

    &-image {
      margin-bottom: 25px;
    }

    &-left-column {
      width: 100%;
      flex-shrink: 0;
    }

    &-right-column {
      width: 100%;
      flex-shrink: 0;
    }
    &-list {
      display: grid;
      gap: 30px;
      grid-template-columns: 1fr;
    }

    &-articles-recommended-header {
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.md}) {
    .article {
      &-list {
        grid-template-columns: 1fr 1fr;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}) {
    .article {
      &-column-wrapper {
        flex-direction: row;
      }

      &-left-column {
        width: calc(66.6666% - 15px);
      }

      &-right-column {
        width: calc(33.3333% - 15px);
      }
    }
  }
`;

const Article: FC<{
  pageContext: {
    siteConfig: IConfig;
    article: IArticle;
    articlesPopular: IArticle[];
    categories: string[];
    language: string;
  };
}> = ({ pageContext: { siteConfig, article, articlesPopular, categories, language } }) => {
  return (
    <Layout pageName="article" language={language} config={siteConfig} categories={categories}>
      <Breadcrumbs
        language={language}
        items={[
          { label: breadcrumbs[language].articles, link: routing[language].articles + '/' },
          { label: article.name },
        ]}
        config={siteConfig}
      />
      <div className="container">
        <Styles $config={siteConfig}>
          <div className="article-column-wrapper">
            <div className="article-left-column">
              <EntireArticleBox language={language} config={siteConfig} article={article} />
            </div>
            <div className="article-right-column">
              <CategoriesSide
                language={language}
                config={siteConfig}
                categories={categories}
                activeCategory={article.categoryName}
                activeCategoryClickable={true}
              />
              <ArticlesRecommended language={language} config={siteConfig} articles={articlesPopular} />
            </div>
          </div>
        </Styles>
      </div>
    </Layout>
  );
};

export default Article;

export const Head: FC<{
  pageContext: {
    siteConfig: IConfig;
    article: IArticle;
    googleSiteVerification: string;
    iconUrl: string;
    language: string;
    rootUrl: string;
  };
}> = ({ pageContext: { siteConfig, article, googleSiteVerification, iconUrl, language, rootUrl } }) => (
  <>
    <html lang={`${language?.toLowerCase()}-${language?.toUpperCase()}`} />
    {googleSiteVerification ? <meta name="google-site-verification" content={googleSiteVerification} /> : null}
    <SEO
      meta={{
        title: article.seoTitle,
        description: article.seoDescription,
      }}
      breadcrumbsSchema={[
        {
          label: breadcrumbs[language].articles,
          link: `${rootUrl}${routing[language].articles}`,
        },
        { label: article.name },
      ]}
      fonts={siteConfig.general.content.fonts}
      gtmCode={siteConfig.general.gtm}
      iconUrl={iconUrl}
    />
  </>
);
